import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.geofence`. */
export const editGeofence = async (geofence): Promise<any> => writeSettingsFields({ geofence });
